<template>
  <div class="wrapper contact-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <h1>{{ $t("CONTACT") }}</h1>
          <p class="notice">
            {{ $t("To contact customer support,") }}<br />
            {{ $t("please send your inquiry using the form below.") }}
          </p>
          <div class="form">
            <form>
              <div class="input-area">
                <input type="text" name="userid" :value="userid" readonly />
              </div>
              <div class="input-area select">
                <select name="type">
                  <option value="" selected>
                    {{ $t("Select your inquiry") }}
                  </option>
                  <option :value="$t('Login / Password')">
                    {{ $t("Login / Password") }}
                  </option>
                  <option :value="$t('Deposit / Withdrawal')">
                    {{ $t("Deposit / Withdrawal") }}
                  </option>
                  <option :value="$t('Two-step verification / Email address')">
                    {{ $t("Two-step verification / Email address") }}
                  </option>
                  <option :value="$t('Plan Purchase')">
                    {{ $t("Plan Purchase") }}
                  </option>
                  <option :value="$t('Bonus / AP Rewards')">
                    {{ $t("Bonus / AP Rewards") }}
                  </option>
                  <option :value="$t('Cancellation')">
                    {{ $t("Cancellation") }}
                  </option>
                  <option :value="$t('Others')">
                    {{ $t("Others") }}
                  </option>
                </select>
              </div>
              <div class="input-area">
                <input
                  type="email"
                  name="email"
                  :placeholder="$t('Email address')"
                />
              </div>
              <div class="input-area">
                <textarea
                  name="question"
                  :placeholder="$t('Please enter your question in detail.')"
                ></textarea>
              </div>
              <div class="form-btn">
                <button class="link-over">
                  {{ $t("Contact") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <Footer title="Contact" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Contact",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "Contact",
      mail: "OOOOO@OOO.com",
      userid: "testtest（ユーザーのidを表示）",
    };
  },
  methods: {},
  computed: {},
  mounted: function () {},
};
</script>
